module.exports = __webpack_public_path__ + "static/media/note2.2e860b1c.png";